import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import * as Sentry from '@sentry/browser';

import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

// Redux modules to support application offline features
import { PersistGate } from 'redux-persist/es/integration/react';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { createOffline } from '@redux-offline/redux-offline';
import offlineConfig from '@redux-offline/redux-offline/lib/defaults';

import Login from './containers/Login';
import { bootstrap } from './store/actions/application';
import { effect, discard } from './services/servicesRedux';
import PrivateRoutes from './privateRoutes';

import reducers from './store/reducers';
import handleAppVersion from './utils/cacheCleaner';

import 'react-toastify/dist/ReactToastify.min.css';
import './css/index.scss';


const persistConfig = {
  timeout: 0,
  key: 'root',
  storage
};

const {
  middleware: offlineMiddleware,
  enhanceReducer: offlineEnhanceReducer,
  enhanceStore: offlineEnhanceStore
} = createOffline({
  ...offlineConfig,
  persist: false,
  effect,
  discard
});

const middlewares = [thunk, offlineMiddleware];
process.env.REACT_APP_environment !== 'production' && middlewares.push(logger);

const persistedReducer = persistReducer(persistConfig, offlineEnhanceReducer(reducers));

const store = createStore(
  persistedReducer,
  {},
  compose(offlineEnhanceStore, applyMiddleware(...middlewares))
);

const history = createBrowserHistory();
const persistor = persistStore(store);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentWillMount() {
    handleAppVersion();

    store.dispatch(bootstrap());
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <Router history={history}>
            <Switch>
              <Route path="/login" exact component={Login} />
              <PrivateRoutes />
            </Switch>
          </Router>
        </PersistGate>
      </Provider>
    );
  }
}

ReactDOM.render(<App />, global.document.getElementById('main'));
